import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    Button, Select, MenuItem, InputLabel, FormControl, Grid,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography,
    FormControlLabel,
    Checkbox
} from '@material-ui/core';
import TreeClient from '../../components/treeClient';
import Axios from 'axios';

class EvolutionCaClient extends Component {
    currentYear = new Date().getFullYear();
    state = {
        client: '',
        annee: new Date().getFullYear(),
        moisDebut: 1,
        moisFin: 12,
        tournee: 'tout',
        synthese: false,
        deductAvoir: false,
        caData: {
            clientData: [],
            filteredTotals: {},
            globalTotals: {}
        },
        loading: false,
        error: null,
        
    };

    handleChangeClient = (data) => {
        this.setState({ client: data });
    };

    onChange = (data, labelState) => {
        this.setState({ [labelState]: data });
    };

    generateBaseParams = () => {
        let params = `annee=${this.state.annee}&moisDebut=${this.state.moisDebut}&moisFin=${this.state.moisFin}`;

        if (this.state.client) {
            params += `&clients=${this.state.client}`;
        }

        if (this.state.tournee !== 'tout') {
            params += `&tournee=${this.state.tournee === 'tournee' ? 1 : 0}`;
        }

        params += `&synthese=${this.state.synthese ? 1 : 0}`;
        params += `&deductAvoir=${this.state.deductAvoir ? 1 : 0}`;
        return params;
    };

    fetchCaData = async () => {
        this.setState({ loading: true, error: null });

        const params = this.generateBaseParams();
        const apiUrl = `https://extensia-france.com/printers/analyseca.php?${params}&output=json`;

        try {
            const response = await Axios.get(apiUrl);
            const data = response.data;

            this.setState({
                caData: {
                    clientData: data.mergedResults,
                    filteredTotals: data.total_filtre_values,
                    globalTotals: data.total_global_values
                },
                loading: false
            });
        } catch (error) {
            console.error("Erreur lors du chargement des données CA :", error);
            this.setState({ error: "Erreur lors du chargement des données.", loading: false });
        }
    };

    handleShowEvolution = () => {
        this.fetchCaData();
    };

    handlePrintPdf = () => {
        const params = this.generateBaseParams();
        const exportUrl = `https://extensia-france.com/printers/analyseca.php?${params}`;
        window.open(exportUrl, '_blank');
    };

    render() {
        const { annee, moisDebut, moisFin, tournee, caData, loading, error } = this.state;
        const currentYear = annee;
        const previousYear = annee - 1;
        const yearBeforePrevious = annee - 2;
        const isCurrentYear = annee === new Date().getFullYear();

        const tableHeaders = [
            'Client',
            `CA ${currentYear}`,
            'CA à Venir',
            'N/N-1',
            `CA ${previousYear}`,
            'N-1/N-2',
            `CA ${yearBeforePrevious}`,
            'N-2/N'
        ];

        return (
            <div className="d-flex flex-column align-items-center p-4">
            <h3 className="mb-4">Évolution Chiffre d'Affaires Client</h3>

            <div className="container-fluid">
                <Grid container spacing={2} alignItems="flex-start" className="mb-4">
                <Grid item xs={12} sm={6} md={2}>
                    <TreeClient handleChange={this.handleChangeClient} />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                    <FormControl fullWidth variant="outlined" margin="dense">
                    <InputLabel>Année</InputLabel>
                    <Select
                        value={annee}
                        onChange={e => this.onChange(e.target.value, 'annee')}
                        label="Année"
                    >
                        {[...Array(10)].map((_, i) => {
                        const year = new Date().getFullYear() - i;
                        return <MenuItem key={year} value={year}>{year}</MenuItem>;
                        })}
                    </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                    <FormControl fullWidth variant="outlined" margin="dense">
                    <InputLabel>Mois Début</InputLabel>
                    <Select
                        value={moisDebut}
                        onChange={e => this.onChange(e.target.value, 'moisDebut')}
                        label="Mois Début"
                        disabled={!isCurrentYear}
                    >
                        <MenuItem value={1}>Janvier</MenuItem>
                        <MenuItem value={2}>Février</MenuItem>
                        <MenuItem value={3}>Mars</MenuItem>
                        <MenuItem value={4}>Avril</MenuItem>
                        <MenuItem value={5}>Mai</MenuItem>
                        <MenuItem value={6}>Juin</MenuItem>
                        <MenuItem value={7}>Juillet</MenuItem>
                        <MenuItem value={8}>Août</MenuItem>
                        <MenuItem value={9}>Septembre</MenuItem>
                        <MenuItem value={10}>Octobre</MenuItem>
                        <MenuItem value={11}>Novembre</MenuItem>
                        <MenuItem value={12}>Décembre</MenuItem>
                    </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                    <FormControl fullWidth variant="outlined" margin="dense">
                    <InputLabel>Mois Fin</InputLabel>
                    <Select
                        value={moisFin}
                        onChange={e => this.onChange(e.target.value, 'moisFin')}
                        label="Mois Fin"
                        disabled={!isCurrentYear}
                    >
                        <MenuItem value={1}>Janvier</MenuItem>
                        <MenuItem value={2}>Février</MenuItem>
                        <MenuItem value={3}>Mars</MenuItem>
                        <MenuItem value={4}>Avril</MenuItem>
                        <MenuItem value={5}>Mai</MenuItem>
                        <MenuItem value={6}>Juin</MenuItem>
                        <MenuItem value={7}>Juillet</MenuItem>
                        <MenuItem value={8}>Août</MenuItem>
                        <MenuItem value={9}>Septembre</MenuItem>
                        <MenuItem value={10}>Octobre</MenuItem>
                        <MenuItem value={11}>Novembre</MenuItem>
                        <MenuItem value={12}>Décembre</MenuItem>
                    </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                    <FormControl fullWidth variant="outlined" margin="dense">
                    <InputLabel>Tournée</InputLabel>
                    <Select
                        value={tournee}
                        onChange={e => this.onChange(e.target.value, 'tournee')}
                        label="Tournée"
                    >
                        <MenuItem value="tout">Tout</MenuItem>
                        <MenuItem value="tournee">Tournée</MenuItem>
                        <MenuItem value="autre">Autre</MenuItem>
                    </Select>
                    </FormControl>
                </Grid>
                   
                <Grid item xs={12} sm={6} md={2} container spacing={1}>
                    <Grid item xs={6}>
                    <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        onClick={this.handleShowEvolution}
                        fullWidth
                        style={{ backgroundColor: '#007bff', color: '#fff', padding: '10px 0' }}
                        disabled={loading}
                    >
                        {loading ? 'Chargement...' : 'Afficher'}
                    </Button>
                    </Grid>
                    <Grid item xs={6}>
                    <Button
                        variant="contained"
                        color="secondary"
                        size="large"
                        onClick={this.handlePrintPdf}
                        fullWidth
                        style={{ backgroundColor: '#6c757d', color: '#fff', padding: '10px 0' }}
                    >
                        Imprimer
                    </Button>
                    <FormControlLabel
                        control={
                        <Checkbox
                            checked={this.state.synthese}
                            onChange={e => this.onChange(e.target.checked, 'synthese')}
                            name="synthese"
                            color="primary"
                        />
                        }
                        label="Synthèse"
                    />
                    <FormControlLabel
                        control={
                        <Checkbox
                            checked={this.state.deductAvoir}
                            onChange={e => this.onChange(e.target.checked, 'deductAvoir')}
                            name="deductAvoir"
                            color="primary"
                        />
                        }
                        label="Déduire les avoirs"
                    />
                    </Grid>
                </Grid>
                </Grid>

                {loading && <Typography variant="h6" align="center">Chargement des données...</Typography>}
                {error && <Typography variant="h6" color="error" align="center">{error}</Typography>}

                {!loading && !error && caData.clientData && caData.clientData.length > 0 && (
                <TableContainer component={Paper} className="mt-4">
                    <Table size="small">
                    <TableHead>
                        <TableRow>
                        {tableHeaders.map((header, index) => (
                            <TableCell key={index} style={{ textAlign: 'center', fontWeight: 'bold' }}>
                            {header}
                            </TableCell>
                        ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {caData.clientData.map((row, index) => (
                        <TableRow key={index}>
                            <TableCell style={{ textAlign: 'center' }}>{row.Client}</TableCell>
                            <TableCell style={{ textAlign: 'center' }}>{(row[`CA_${currentYear}`] || 0).toLocaleString('fr-FR')} €</TableCell>
                            <TableCell style={{ textAlign: 'center' }}>{(row['CA_AVenir'] || 0).toLocaleString('fr-FR')} €</TableCell>
                            <TableCell style={{ textAlign: 'center', color: parseFloat(row['N/N-1']) > 5 ? 'blue' : (parseFloat(row['N/N-1']) < -5 ? 'red' : 'black') }}>
                            {row['N/N-1'] !== "0%" ? row['N/N-1'] : ''}
                            </TableCell>
                            <TableCell style={{ textAlign: 'center' }}>{(row[`CA_${previousYear}`] || 0).toLocaleString('fr-FR')} €</TableCell>
                            <TableCell style={{ textAlign: 'center', color: parseFloat(row['N-1/N-2']) > 5 ? 'blue' : (parseFloat(row['N-1/N-2']) < -5 ? 'red' : 'black') }}>
                            {row['N-1/N-2'] !== "0%" ? row['N-1/N-2'] : ''}
                            </TableCell>
                            <TableCell style={{ textAlign: 'center' }}>{(row[`CA_${yearBeforePrevious}`] || 0).toLocaleString('fr-FR')} €</TableCell>
                            <TableCell style={{ textAlign: 'center', color: parseFloat(row['N-2/N']) > 5 ? 'blue' : (parseFloat(row['N-2/N']) < -5 ? 'red' : 'black') }}>
                            {row['N-2/N'] !== "0%" ? row['N-2/N'] : ''}
                            </TableCell>
                        </TableRow>
                        ))}
                        <TableRow style={{ fontWeight: 'bold' }}>
                        <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Total Filtré</TableCell>
                        <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>{(caData.filteredTotals[`CA_${currentYear}`] || 0).toLocaleString('fr-FR')} €</TableCell>
                        <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>{(caData.filteredTotals['CA_AVenir'] || 0).toLocaleString('fr-FR')} €</TableCell>
                        <TableCell style={{ textAlign: 'center', fontWeight: 'bold', color: parseFloat(caData.filteredTotals['N/N-1']) > 5 ? 'blue' : (parseFloat(caData.filteredTotals['N/N-1']) < -5 ? 'red' : 'black') }}>
                            {caData.filteredTotals['N/N-1'] !== "0%" ? caData.filteredTotals['N/N-1'] : ''}
                        </TableCell>
                        <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>{(caData.filteredTotals[`CA_${previousYear}`] || 0).toLocaleString('fr-FR')} €</TableCell>
                        <TableCell style={{ textAlign: 'center', fontWeight: 'bold', color: parseFloat(caData.filteredTotals['N-1/N-2']) > 5 ? 'blue' : (parseFloat(caData.filteredTotals['N-1/N-2']) < -5 ? 'red' : 'black') }}>
                            {caData.filteredTotals['N-1/N-2'] !== "0%" ? caData.filteredTotals['N-1/N-2'] : ''}
                        </TableCell>
                        <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>{(caData.filteredTotals[`CA_${yearBeforePrevious}`] || 0).toLocaleString('fr-FR')} €</TableCell>
                        <TableCell style={{ textAlign: 'center', fontWeight: 'bold', color: parseFloat(caData.filteredTotals['N-2/N']) > 5 ? 'blue' : (parseFloat(caData.filteredTotals['N-2/N']) < -5 ? 'red' : 'black') }}>
                            {caData.filteredTotals['N-2/N'] !== "0%" ? caData.filteredTotals['N-2/N'] : ''}
                        </TableCell>
                        </TableRow>
                        <TableRow style={{ fontWeight: 'bold' }}>
                        <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Total Général</TableCell>
                        <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>{(caData.globalTotals[`CA_${currentYear}`] || 0).toLocaleString('fr-FR')} €</TableCell>
                        <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>{(caData.globalTotals['CA_AVenir'] || 0).toLocaleString('fr-FR')} €</TableCell>
                        <TableCell style={{ textAlign: 'center', fontWeight: 'bold', color: parseFloat(caData.globalTotals['N/N-1']) > 5 ? 'blue' : (parseFloat(caData.globalTotals['N/N-1']) < -5 ? 'red' : 'black') }}>
                            {caData.globalTotals['N/N-1'] !== "0%" ? caData.globalTotals['N/N-1'] : ''}
                        </TableCell>
                        <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>{(caData.globalTotals[`CA_${previousYear}`] || 0).toLocaleString('fr-FR')} €</TableCell>
                        <TableCell style={{ textAlign: 'center', fontWeight: 'bold', color: parseFloat(caData.globalTotals['N-1/N-2']) > 5 ? 'blue' : (parseFloat(caData.globalTotals['N-1/N-2']) < -5 ? 'red' : 'black') }}>
                            {caData.globalTotals['N-1/N-2'] !== "0%" ? caData.globalTotals['N-1/N-2'] : ''}
                        </TableCell>
                        <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>{(caData.globalTotals[`CA_${yearBeforePrevious}`] || 0).toLocaleString('fr-FR')} €</TableCell>
                        <TableCell style={{ textAlign: 'center', fontWeight: 'bold', color: parseFloat(caData.globalTotals['N-2/N']) > 5 ? 'blue' : (parseFloat(caData.globalTotals['N-2/N']) < -5 ? 'red' : 'black') }}>
                            {caData.globalTotals['N-2/N'] !== "0%" ? caData.globalTotals['N-2/N'] : ''}
                        </TableCell>
                        </TableRow>
                    </TableBody>
                    </Table>
                </TableContainer>
                )}
            </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(EvolutionCaClient);
